import { render, staticRenderFns } from "./IntegrationDetailing.vue?vue&type=template&id=a89b7cc4&scoped=true&"
import script from "./IntegrationDetailing.vue?vue&type=script&lang=ts&"
export * from "./IntegrationDetailing.vue?vue&type=script&lang=ts&"
import style0 from "./IntegrationDetailing.vue?vue&type=style&index=0&id=a89b7cc4&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a89b7cc4",
  null
  
)

export default component.exports